<template>
    <div class="group map">
        <div class="productDetails routeSelection">
        </div>
    </div>
</template>
<script>
// /* global Helpers */
import { BreedingRhombusSpinner } from 'epic-spinners'

export default{
    components: { BreedingRhombusSpinner },
    props: {
        domain: { default: 'https://beta.eddmeasy.com' },
        modal: { default: false },
        page: { default: 'default' },
        page_id: { default: 0 },
        timeout: { default: 45000 },
        product_name: { default: 'EDDM' },
        map_class: { default: 'map' },
        reloading: { default: false },
        product: { default: '5c00d75f-058a-49c0-b75e-6346de98882c' },
        runsize: { default: null },
        colorspec: { default: null },
        coating: { default: null },
        bleed: { default: null },
        width: { default: null },
        height: { default: null },
        accessToken: { default: null },
        date: { default: '2018-05-11' },
        pr_up: { default: 'NjA=' },
        po_up: { default: 'My40' },
        se_up: { default: 'MzU=' },
        eddm_button_text: { default: 'Continue to next step' },
        show_eddm_service_price: { default: true }
    },
    data () {
        return {
            productInfo: null,
            productOptions: null,
            routeInfo: null
        }
    },
    mounted () {
        this.init()
        this.buildMap()

        var eddmheight = $(window).height() - 120
        $('.map').css('height', eddmheight)
    },
    methods: {
        init (config) {
            // Listen for map events
            window.addEventListener('message', (e) => {
                // If 'message' didn't come from the EDDM Map, do nothing
                if (e.origin !== (this.domain)) { return }

                // Do something with e.data
                if (e.data.type === 'login_sync') {
                    if (this.modal === false && this.reloading === false) {
                        // Product Page
                        // ProductSelector.nextSet()
                    } else {
                        // Modal
                        this.reloading = false
                    }
                }

                if (e.data.type === 'map_event_data_sync') {
                    this.routeInfo = e.data.data
                    $('#map').css('opacity', 1.0)
                }

                // Do something with e.data
                if (e.data.type === 'next_button_sync') {
                    console.log('next fire')
                    this.$emit('saveEddmData', e.data)
                    // if (this.modal === false) {
                    //     // Product Page
                    //     this.eddmPanel()
                    //     this.eddmInfo(e.data.data)

                    //     // $('.' + this.map_class).slideUp('fast')

                    //     // $('.routeContainer, .navToggle').off();

                    //     setTimeout(function () {
                    //         // ProductSelector.nextSet()
                    //     }, 250)
                    // } else {
                    //     // Modal
                    //     // Update Eddm
                    //     $.ajax({
                    //         type: 'POST',
                    //         url: '/ajax/eddm/update-cart',
                    //         timeout: this.timeout,
                    //         data: {id: this.page_id, eddm: e.data.data, token: this.accessToken},
                    //         dataType: 'json',
                    //         success: function (data) {
                    //             location.reload()
                    //         },
                    //         error: function (data) {
                    //             // Growl.showhide('Sorry, we\'re having trouble with our EDDM map at the moment. Please try again later.')
                    //         }
                    //     })
                    //     // Update Route?
                    //     // Update Cart
                    // }
                }
            })
        },

        buildMap () { // product_uuid, token
            // $('#map').remove()

            this.checkRequired()

            // Fetch Eddm Info from Database
            // this.product
            this.axios.post('/eddm/product-options', {product: this.product, token: this.accessToken})
            .then((response) => {
                let xOptions = response.data.data
                this.productOptions = response.data.data

                // this.coating = response.data.data.Coating
                // '5c00d75f-058a-49c0-b75e-6346de98882c'
                // '&options[]=121bb7b5-3b4d-429f-bd8d-bbf80e953313&options[]=13abbda7-1d64-4f25-8bb2-c179b224825d&options[]=8a3a0fd1-38ae-49a0-8736-3fedadc3dc93&options[]=aa0227f0-877e-4ecd-bdfd-d220d74098db&options[]=74c3d2c5-af98-4f3f-9634-d0f91f3c3ea9&options[]=cb84e4f5-cf63-4c25-b3c3-d22fc7dcf09d&options[]=e629d351-623c-48f6-b5ea-db43d1387a97'
                // Init iFrame
                var ifr = $('<iframe/>', {
                    id: 'map',
                    src: this.domain,
                    frameborder: 0,
                    width: '100%',
                    load: () => {
                        var iframe = document.getElementById('map').contentWindow
                        var productOptions = '&options[]=' + response.data.data.Coating + '&options[]=' + this.colorspec + '&options[]=' + this.runsize + xOptions.options

                        var data = {
                            type: 'eddm_start',
                            apiUrl: 'https://api.4over.com',
                            access_token: this.accessToken,
                            date: this.date,
                            product_uuid: this.product,
                            product_options: productOptions,
                            product_name: 'EDDM',
                            map_event_data: this.routeInfo,
                            postage_markup_percentage: this.decode(this.po_up),
                            product_markup_percentage: this.decode(this.pr_up),
                            eddm_service_markup_percentage: this.decode(this.se_up),
                            show_eddm_service_price: this.show_eddm_service_price,
                            next_button_text: this.eddm_button_text
                        }
                        //  var data = {
                        //     type: 'eddm_start',
                        //     apiUrl: 'https://api.4over.com',
                        //     access_token: this.accessToken,
                        //     date: this.date,
                        //     product_uuid: this.product,
                        //     product_options: productOptions,
                        //     product_name: this.product_name,
                        //     map_event_data: this.routeInfo,
                        //     postage_markup_percentage: this.decode(this.po_up),
                        //     product_markup_percentage: this.decode(this.pr_up),
                        //     eddm_service_markup_percentage: this.decode(this.se_up),
                        //     show_eddm_service_price: this.show_eddm_service_price,
                        //     next_button_text: this.eddm_button_text
                        // }
                        console.log(data)
                        iframe.postMessage(data, this.domain)

                        var eddmheight = $('.map').height()

                        $('#map').css('height', eddmheight)
                        // $('.productDetails.routeSelection').css('min-height', eddmheight)
                    }
                })

                if (this.modal) {
                    console.log(1)
                    // EddmRoutes()
                } else {
                    console.log(2)
                    // this.getRoutes()
                }

                $('.map').append(ifr)
                $('.map').attr('data-bleed', this.bleed)

                var productBleedsize = parseFloat(this.bleed)
                var productWidthsize = parseFloat(this.width) + productBleedsize
                var productHeightsize = parseFloat(this.height) + productBleedsize

                $('.sizeWidth').html(productWidthsize)
                $('.sizeHeight').html(productHeightsize)
                $('.js-selectorpad').removeClass('d-block').addClass('d-none')
            })
            .catch(function (err) {
                console.log(err)
                // Helpers.errorPop('Error', err.response.data.message)
            })
        },

        openMap (id, openFrom = 'default', token) {
            // Pull and set data for the map
            if (openFrom !== 'default') {
                if (openFrom === 'cart') {
                    this.eddm_button_text = 'Update Cart'
                } else if (openFrom === 'order') {
                    this.eddm_button_text = 'Update Job'
                }

                this.modal = true
                this.page = openFrom
                this.page_id = id

                $.ajax({
                    type: 'POST',
                    url: '/ajax/eddm/fetch-data',
                    timeout: this.timeout,
                    data: {id: id, type: openFrom, token: token},
                    dataType: 'json',
                    success: function (data) {
                        this.init({
                            product: data.eddm.product_data.product_uuid,
                            runsize: data.eddm.product_data.runsize_uuid,
                            colorspec: data.eddm.product_data.colorspec_uuid,
                            date: data.eddm.delivery_date,
                            accessToken: data.token,
                            pr_up: this.encode(data.eddm.product_markup_percentage.toString()),
                            po_up: this.encode(data.eddm.postage_markup_percentage.toString())
                        })

                        this.productInfo = data.eddm
                        this.routeInfo = data.eddm.map_event_data
                        this.injectModal()
                    }
                })

            // Product Page - Just load the map
            } else {
                this.buildMap()
            }
        },

        setMapButton (text) {
            var iframe = document.getElementById(this.frame_id).contentWindow

            var data = {
                type: 'next_button_text_update',
                next_button_text: text
            }

            iframe.postMessage(data, this.domain)
        },

        injectModal () {
            let template = `
                <div class="mapModal"></div>
            `

            $('body').append(template)

            this.buildMap()
        },

        eddmPanel () {
            $('.scheduleEstimate').show()
            $('.set-buttons a.shipping').html('<span data-icon="" title="shipping"></span> EDDM<span>&reg;</span><b></b>')
            $('.detailstepTwo').remove()
            $('.detailstepThree').show().removeClass('detailstepThree').addClass('detailstepTwo')
        },

        eddmInfo (data) {
            this.productInfo = data

            var $standardPrice = window.productPricing.filter(function (obj) {
                return obj.runsize_uuid === data.product_data.runsize_uuid
            })

            // $('.eddmDelivery').html(moment(data.delivery_date).format('dddd, MMMM Do YYYY'))
            // $('.eddmResidential').html(data.map_event_data.tot_res)
            // $('.eddmBusiness').html(data.map_event_data.tot_bus)
            // $('.eddmTotalAddresses').html(data.map_event_data.tot_cnt)
            // $('.eddmProdCost').html('$' + this.number_format((data.product_price), 2))
            $('.baseproduct').html('Retail Price: <s><span>$' + $standardPrice[0].base + '</span></s>')
            // $('.eddmProductCost').after('<div class="row"><div class="col-6 pr-0"><label for="estimated" class="mb-0 type-85 vertical-align d-block font-200">EDDM<span class="superscript">&reg;</span> Service Cost</label></div><div class="eddmProdCost totalDays text-right font-500 mb-2 type-150 col-6">$' + this.number_format((data.eddm_service_price), 2) + '</div></div>')
            // $('.eddmShipCost').html('$' + this.number_format(data.postage_price, 2))
            // $('.eddmTotalCost').html('$' + this.number_format(data.total_price, 2))

            $('.js-selectorpad').removeClass('d-none').addClass('d-block')

            // Set Summary Info
            var description = 'test'
            // var description = selectedProds[0].description
            // var runsize = data.friendly_product_data.Runsize
            // var sets = '1'
            var subtotal = (data.product_price + data.eddm_service_price)
            var shipping = data.postage_price
            var design = 0

            if ($('select[name=artwork]').length) {
                design = parseFloat($('select[name=artwork] option:selected').data('price'))
            }

            $('.summaryProduct').html(description)
            $('.summaryLeft ul li:nth-child(2)').html('<label>Routes Selected:</label><div class="summarySets">' + data.map_event_data.tot_sel + '</div>')
            $('.summaryLeft ul li:nth-child(3)').html('<label>Total Addresses:</label><div class="summarySets">' + data.map_event_data.tot_cnt + '</div>')
            $('.summaryRight ul li:nth-child(2) label').html('Product:')
            $('.summaryRight ul li:nth-child(3) label').html('Postage:')
            $('.summaryRight ul li:nth-child(2)').after('<li class="group"><label class="total">EDDM<span class="superscript">&reg;</span> Service:</label><div class="cost">$' + this.number_format((data.eddm_service_price), 2) + '</div></li>')
            $('.costSubtotal').html('$' + this.number_format((data.product_price + design), 2, '.', ','))
            $('.costShipping').html('$' + this.number_format(shipping, 2, '.', ','))
            $('.costTotal').html('$' + this.number_format((parseFloat(subtotal) + parseFloat(shipping) + design), 2, '.', ','))
        },

        checkRequired () {
            if (this.product === null) {
                return true
            } else if (this.runsize === null) {
                return true
            } else if (this.colorspec === null) {
                return true
            } else if (this.accessToken === null) {
                return true
            } else if (this.date === null) {
                return true
            }
        },

        getRoutes: function () {
            // Make Ajax Call to Fetch
            $.ajax({
                type: 'GET',
                url: this.domain + '/routes',
                dataType: 'json',
                success: (data) => {
                    // this.$set('routes',routes);
                    this.routes = data
                    //     {"id":1, "name":"Huntersville, NC","routes":7,"residential":1378,"business":652},

                    this.routeButtons()

                    $('.updateRoute').on('click', function () {
                        $('.commitSave').attr('data-type', 'update')
                        this.routeSave()
                        return false
                    })

                    $('.saveRoute').on('click', function () {
                        $('.commitSave').attr('data-type', 'new')
                        this.routeSave()
                        return false
                    })

                    $('.commitSave').on('click', function () {
                        var type = $(this).data('type')
                        this.saveRoute(type)
                        return false
                    })

                    $('.cancelSave').on('click', function () {
                        this.routeButtons()
                        return false
                    })

                    $('input[name=routeName]').keypress(function (e) {
                        if (e.which === 13) {
                            var type = $('.commitSave').data('type')
                            this.saveRoute(type)
                            return false
                        }
                    })

                    if (this.routes.length === 0) {
                        this.addTutorial()
                    }
                },
                error: function (data) {
                    // Growl.showhide('Sorry, there was an error processing your request.', 4000);
                }
            })
        },
        saveRoute: function (type) {
            var url = this.domain + '/route'
            var name = $('input[name=routeName]').val()

            if (this.routeInfo === null || this.routeInfo === undefined) {
                // Growl.showhide('No routes have been selected to save.')
            } else if (name === '') {
                // Growl.showhide('Route group name is required.')
            } else {
                if (type === 'update') {
                    url = url + '/' + $('li.route.active').data('id')
                }

                var send = {
                    name: $('input[name=routeName]').val(),
                    routes: this.routeInfo.tot_sel,
                    residential: this.routeInfo.tot_res,
                    business: this.routeInfo.tot_bus,
                    data: this.routeInfo
                }

                $.ajax({
                    type: 'POST',
                    url: url,
                    dataType: 'json',
                    data: send,
                    success: (data) => {
                        if (this.routes[0].class === 'tutorial') {
                            this.routes.splice(0, 1)
                        }

                        this.routes.push({'id': data.id, 'name': data.name, 'routes': data.routes, 'residential': data.residential, 'business': data.business})
                    },
                    error: function (data) {
                        // Growl.showhide('Sorry, there was an error processing your request.', 4000);
                    }
                })

                $('input[name=routeName]').val('')
                this.routeButtons()
            }
        },
        routeButtons: function () {
            $('.route_functions').removeClass('rSave').addClass('rButtons')
        },
        routeSave: function () {
            $('.route_functions').removeClass('rButtons').addClass('rSave')
            $('input[name=routeName]').focus()
        },
        addTutorial: function () {
            this.routes.push({'id': null, 'name': 'Saving Routes:', 'routes': "Here you can save routes to easily manage and reuse on future orders. Save the currently selected routes using the 'Save Route Group' button above, select an exsiting route group to apply it to the map or click the 'X' next to a route group to remove it from the list.", 'class': 'tutorial'})
        },
        select: function (index) {
            if (this.routes[index].id !== null) {
                $('.routes_list ul li').removeClass('active')
                $('.routes_list ul li:nth-child(' + (index + 1) + ')').addClass('active')

                var id = $('.routes_list ul li:nth-child(' + (index + 1) + ')').data('id')

                this.options.reloading = true

                this.reOpenMap(id)
            }
        },
        delete: function (index, event) {
            event.preventDefault()

            var $t = this
            var id = $('.routes_list ul li:nth-child(' + (index + 1) + ')').data('id')

            $.ajax({
                type: 'DELETE',
                url: $t.url + '/route/' + id,
                dataType: 'json',
                success: function (data) {
                    $t.routes.splice(index, 1)

                    if ($t.routes.length === 0) {
                        $t.addTutorial()
                    }
                },
                error: function (data) {
                    // Growl.showhide('Sorry, there was an error processing your reques$t.', 4000);
                }
            })

            return false
        },

        encode (data) {
            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
            var o1
            var o2
            var o3 = 0
            var h1 = 0
            var h2 = 0
            var h3 = 0
            var h4 = 0
            var bits = 0
            var i = 0
            var ac = 0
            var enc = ''
            var tmpArr = []

            if (!data) {
                return data
            }

            do { // pack three octets into four hexets
                o1 = data.charCodeAt(i++)
                o2 = data.charCodeAt(i++)
                o3 = data.charCodeAt(i++)

                bits = o1 << 16 | o2 << 8 | o3

                h1 = bits >> 18 & 0x3f
                h2 = bits >> 12 & 0x3f
                h3 = bits >> 6 & 0x3f
                h4 = bits & 0x3f

                // use hexets to index into b64, and append result to encoded string
                tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4)
            } while (i < data.length)

            enc = tmpArr.join('')

            var r = data.length % 3

            return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3)
        },

        decode (data) {
            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
            var o1 = 0
            var o2 = 0
            var o3 = 0
            var h1 = 0
            var h2 = 0
            var h3 = 0
            var h4 = 0
            var bits = 0
            var i = 0
            var ac = 0
            var dec = ''
            var tmpArr = []

            if (!data) {
                return data
            }

            data += ''

            do { // unpack four hexets into three octets using index points in b64
                h1 = b64.indexOf(data.charAt(i++))
                h2 = b64.indexOf(data.charAt(i++))
                h3 = b64.indexOf(data.charAt(i++))
                h4 = b64.indexOf(data.charAt(i++))

                bits = h1 << 18 | h2 << 12 | h3 << 6 | h4

                o1 = bits >> 16 & 0xff
                o2 = bits >> 8 & 0xff
                o3 = bits & 0xff

                if (h3 === 64) {
                    tmpArr[ac++] = String.fromCharCode(o1)
                } else if (h4 === 64) {
                    tmpArr[ac++] = String.fromCharCode(o1, o2)
                } else {
                    tmpArr[ac++] = String.fromCharCode(o1, o2, o3)
                }
            } while (i < data.length)

            dec = tmpArr.join('')

            return dec
        },

        number_format (number, decimals, decPoint, thousandsSep) {
            number = (number + '')
            .replace(/[^0-9+\-Ee.]/g, '')

            var n = !isFinite(+number) ? 0 : +number
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            var s = ''

            var toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec)
                return '' + Math.round(n * k) / k
            }

            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
            .split('.')

            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
            }

            if ((s[1] || '')
                .length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1)
                    .join('0')
            }
            return s.join(dec)
        }
    }
}
</script>

<style scoped>
    .map {
        display: block;
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// EddmMap.vue?9c7aff66